import { Component, OnInit } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
import { NavigationService } from 'src/app/_services/navigation';
import { ActivatedRoute, Router } from '@angular/router';
import Util from 'src/app/_helpers/util';
import Getcurrency from 'src/app/_helpers/currency';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { config } from 'src/app/config';
import { RfqProcurementService } from 'src/app/_services/rfqprocurement.services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from 'src/app/components/modal/modal.component';
import { PopupmessagingComponent } from 'src/app/components/popupmessaging/popupmessaging.component';
import { Popupmodal } from 'src/app/_helpers/popupmodal';
import { RatingService } from 'src/app/_services/rating.services';
import { TranslateService } from '@ngx-translate/core';
import { ProductService } from 'src/app/_services/product.services';
import CheckErrortype from 'src/app/_helpers/check-errortype';
import { LightGallery } from 'lightgallery/lightgallery';

import html2canvas from 'html2canvas';
import jspdf from 'jspdf';

const queryRfq = gql`
query rfqDetail($rfqId: ID!){
  getRfqDetail(input: {
      rfqId: $rfqId
  }) {
    id
    companyLocation {
        id
        label
        country
        province
        city
        street
        postalCode
        phone
        taxId
        isMainAddress
    }
    state
    approvalStatus
    ongoingApprovalStatus
    rfqDisplayId
    description,
    submitQuotationLastDate
    paymentTermRequestedInDays
    etaRequested
    currency
    procurementRefNumber
    isForFullQuote
    isIndentAccepted
    expiredDate
    rfqItem {
        id
        name
        brand
        description
        qtyNeeded
        manufacturerSku
        itemSequence
        itemUnit
    }
    rfqVendorCategory {
        id
        category
    }
    totalVendorParticipation
    createdDate
    createdBy
    modifiedDate
    modifiedBy
  }
}
`;

const changeSateRfq = gql`
mutation changeRfqState($action: stateAction!,$rfqId: ID!) {
  changeRfqState(input: {
    rfqId: $rfqId
    action: $action
  })
}
`;

const deleteRfq = gql`
mutation deleteRfq($rfqId: ID!) {
  deleteRfq(input: {
    rfqId: $rfqId
  })
}
`;

const getLowestHighestPriceRfq = gql`
query getLowestHighestPrice($rfqId: ID!) {
  getLowestHighestPrice(input: {
    rfqId: $rfqId
  }){
    partialLowest
    partialHighest
    fullQuoteLowest
    fullQuoteHighest   
  }
}`;






const PostUpdateItemRfq = gql`
mutation updateRfqQuotationSelectedQty($rfqId: ID!,$updateRfqQuotationSelectedQtyInputData:[UpdateRfqQuotationSelectedQtyInputData]){
  updateRfqQuotationSelectedQty(input: {
      rfqId: $rfqId
      updateRfqQuotationSelectedQtyInputData: $updateRfqQuotationSelectedQtyInputData
  })
}
`;

const changeRfqApprovalStatus = gql`
mutation changeRfqApprovalStatus($action:ApprovalAction!,$rfqId:ID!){
  changeRfqApprovalStatus(input: {
      action: $action
      rfqId: $rfqId
  }) 
}

`;



@Component({
  selector: 'app-rfq-quoted-preview-export',
  templateUrl: './rfq-quoted-preview-export.component.html',
  styleUrls: ['./rfq-quoted-preview-export.component.scss']
})
export class RfqQuotedPreviewExportComponent implements OnInit {
  rfqId: any
  DataRfq: any = []
  PageLoading: boolean = false
  rfqVendorCategory: any
  displaypublish='none'
  statusRfq = ''
  successpublish='none'
  successvoid='none'

  deleteID : any = []
  deleteName : any = []
  displaydone='none'

  productList:any=[]

  DataLowestHighestPrice:any
  DataCompleteOrderQuotation:any
  DataCompleteOrderQuotationOffer:number=0
  // DataAllVendorQuotationOfferedDataRfq: { [id: string]: any; } = {};  
  DataAllVendorQuotationOfferedDataRfq:any=[]

  allCurrency = Getcurrency.getAllData();
  symbolCurrency:any

  limit:number=100
  offset:number=0 // page-1
  totalAll:number=0
  currentpage:number=1
  totalpage:number=1
  hasprev:boolean=false
  hasnext:boolean=false
  loadingrfqitem:boolean=false
  qtytoooffer: any
  qtytooofferchanges : any
  btnQtyEnable:boolean=false

  datagetRfqItemListDataRfq:any

  sampleArray = new Array(5);

  ArrQtytoOffer:any
  sampleQRFQ=[]

  successcancel='none'


  StatusApproval:number=1 // 1->OPEN , 2->REQUESTED, 4->APPROVED
  Valstate:string=''
  LoadingreqeustApproval:boolean=false
  displayApproveReject='none'
  displaytimeline='none'
  arrMoreLessDesc: any=[];

  emptyItem:boolean=true

  isActivePoExist:boolean=false
  displayisActivePoExist='none'
  getcompanyName: any = ''
  config:any

  completeloadmore : any =[]
  isLoadmore:any =[]
  limitloadmore=50
  offsetloadmore=0 //page
  limitvendorloadmore=100
  totalalldata:any=[]
  offsetperitem:any=[]

  showInviteVendor='none'
  inviteloading:boolean=false
  ValSearchVendor:string=''
  ValinputEmail:string=''
  vendorList:any=[]
  loadvendor:boolean=false
  selectedInvVendor: { id: string; val: string; type: string; }[] =[]
  submitInvEmail:boolean=false
  invalidEmail:boolean=false

  showReccurring='none'
  ValReccurringName:string=''
  loadingReccurring:boolean=false
  invalidRecName:boolean=false
  submitRecc:boolean=false

  totalselected:number=0


  stepAssistance:number=0

  stepAssistanceArray:any=[
    [
      '[{"text":"RFQ Published","status":false},{"text":"Vendor Create Quotation","status":false},{"text":"Order Products","status":false},{"text":"Proforma PO <b>(Done!)</b>","status":false}]'
    ],
    [
      '[{"text":"RFQ Published","status":true},{"text":"Vendor Create Quotation","status":false},{"text":"Order Products","status":false},{"text":"Proforma PO <b>(Done!)</b>","status":false}]'
    ],
    [
      '[{"text":"RFQ Published","status":true},{"text":"Vendor Create Quotation","status":true},{"text":"Order Products","status":false},{"text":"Proforma PO <b>(Done!)</b>","status":false}]'
    ],
    [
      '[{"text":"RFQ Published","status":true},{"text":"Vendor Create Quotation","status":true},{"text":"Order Products","status":true},{"text":"Proforma PO <b>(Done!)</b>","status":false}]'
    ],  
    [
      '[{"text":"RFQ Published","status":true},{"text":"Vendor Create Quotation","status":true},{"text":"Order Products","status":true},{"text":"Proforma PO <b>(Done!)</b>","status":true}]'
    ],   
  ]

  isOrderSelected:boolean = false
  step1: boolean = false;
  step2: number = 0;
  step3: boolean = false;
  step4: boolean = false;

  arrLogo:any=[]
  arrVendorId:any=[]

  arrLogoFull:any=[]
  arrVendorIdFull:any=[]

  dataRfqBoard:any=[]

  lightboxImg:any = [];
  private lightGallery!: LightGallery;
  private needRefresh = false;

  currentUrl:string=''
  valshareData:any

  isApproval:boolean=false





  //---------------//
  PoId: any
  // PageLoading: boolean = false
  datapoDetail:any 
  totalQuotationPrice: number = 0;
  getValueTax:number=0
  isPrint:boolean=false
  companyLogo:any
  companyBase64:any

  //rfqId: any
  quotationId: any =''
  //DataRfq: any = []
  DataQuotation: any = []
  poId:string=''
  companyName:string=""
  companyAddress:string=""
  companyPhone:string=""
  companyEmail:string=""


  
  constructor(
    private apollo: Apollo,
    private navigation: NavigationService,
    private router: Router,
    private route: ActivatedRoute,
    private rfqProcurementService: RfqProcurementService,
    private modalService: NgbModal,
    private popupmodal : Popupmodal,
    private ratingService: RatingService,
    private translate: TranslateService,
    private productService: ProductService
  ) { 
    const getIsApproval = localStorage.getItem("APPROVAL");    
    if (getIsApproval !== null) {
      if(getIsApproval.toLowerCase()=='true'){
        this.isApproval = true;
      }
    } 
       
  }

  ngOnInit(): void {
    const logoUrl = localStorage.getItem("COMPANY_LOGO");

    if (logoUrl) {
      this.convertImageToBase64(logoUrl).then((base64:any) => {
        this.companyBase64 = base64;
      });
    } 

    const storedCompanyName = localStorage.getItem("COMPANYSELECTNAME");
    this.companyName = storedCompanyName ? storedCompanyName : "";    


    this.config = config
    this.getcompanyName = (localStorage.getItem("COMPANYSELECTNAME"))? localStorage.getItem("COMPANYSELECTNAME") : ''

    const userdata = localStorage.getItem("USERDATA");
    if (userdata) {
      const parsed = JSON.parse(userdata);
      this.companyEmail = parsed?.email ?? "";
    }


    this.PageLoading = true

    this.rfqId = this.route.snapshot.paramMap.get('RfqId');
    console.log('rfqId',this.rfqId);
    if(this.rfqId !==''){
      this.rfqDetail()

      this.getRfqItemListDataRfq()
      this.getCompleteOrderQuotationRfq()

      this.getStepper()
    }
    this.currentUrl = window.location.href;
  }
  

  convertImageToBase64(imageUrl: string): Promise<string> {
    return fetch(imageUrl)
      .then(response => response.blob())
      .then(blob => {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result as string);
          reader.readAsDataURL(blob);
        });
      });
  }


  settingsGallery = {
    counter: true,
    download:false,
  };
  itemsGallery:any = []

  onInitGallery = (detail:any): void => {
    this.lightGallery = detail.instance;
  };

  ngAfterViewChecked(): void {
    if (this.needRefresh) {
      if(this.itemsGallery.length>0){
        this.lightGallery.refresh();
        this.needRefresh = false;
      }

    }
  }

  getStepper(){
    this.rfqProcurementService.getRfqStepper(this.rfqId).subscribe((res:any) => {
      if(res.data?.getRfqStepper){

        this.step1 = res.data?.getRfqStepper.isPublished
        this.step2 = res.data?.getRfqStepper.totalQuotationReceive
        this.step3 = res.data?.getRfqStepper.isAlreadyOrder
        this.step4 = res.data?.getRfqStepper.isAlreadySentPo

        if(this.step1){
          this.stepAssistance=1
        }
        if(this.step2>0){
          this.stepAssistance=2
        }
        if(this.step3){
          this.stepAssistance=3
        }
        if(this.step4){
          this.stepAssistance=4
        }





        // step3 && !step4 = Proforma PO Ready
        // step3 && step4 = PO sent

      //   <strong *ngIf="rfq?.haveActivePO" class="mt-1">
      //   <img src="/assets/images/icons/ic_outline-request-quote.png" class="outlineicon pb-2"> 
      //   <font *ngIf="!rfq?.isPoSent">Proforma PO Ready</font>
      //   <font *ngIf="rfq?.isPoSent">PO sent</font>
      // </strong>

      // <strong *ngIf="rfq?.poId" class="mt-1">
      //   <img src="/assets/images/icons/ic_outline-request-quote.png" class="outlineicon pb-2"> Proforma PO Ready
      // </strong>




      }
      else if(res.errors){
        var error = res.errors[0].message
        console.log('error',error);
        var errMsg = error + '';
        var result = errMsg.split(":");
        var resMsg = result[result.length - 1];
        var msg = (resMsg)? resMsg: errMsg
        console.log('msg',msg);
        var errortext = msg

        if(res.errors[0].extensions.type){
          //get translate error, if exsit, replace errortext
          this.translate.get('error.'+res.errors[0].extensions.type).subscribe((data:any)=> {
            if (this.translate.instant('error.'+res.errors[0].extensions.type) !== 'error.'+res.errors[0].extensions.type){
              errortext = data
            }
          });
          //force redirect on specific errortype
          var forceRedirect = CheckErrortype.getResponse(res.errors[0].extensions.type)
          if(forceRedirect){
            window.location.href = forceRedirect
            return
          }
        }
        this.popupmodal.showError(errortext,null).subscribe((res:any) => {})
      }
      else {
        this.popupmodal.showFail().subscribe((res:any) => {})
      }
      
    });
  }

  getImageGallery(rfqItemId:string){
    var img: never[] = []
    this.DataRfq.rfqItem.forEach((e:any,i:any) => {
      if(e['id']==rfqItemId){
        img = e['fileName'];
      }
    });
    return img
  }

  getCodeCurrency(code:any){
    this.allCurrency.forEach((e:any,i:any) => {
      if(e['code']==code){
        this.symbolCurrency=e['symbol']
      }
    });
    console.log('this.symbolCurrency',this.symbolCurrency);
  }

  back(): void {
    this.navigation.back()
  }

  rfqDetail() {
    console.log('rfq-detail', 'rfqDetail()')
    console.log('rfq-detail', 'this.rfqId', this.rfqId)


    this.rfqProcurementService
    .getRrfqDetail(this.rfqId)
    .subscribe((res:any) => {
      console.log('res : ',res)
      if(res.data.getRfqDetail){
        
        console.log('rfq-detail', 'res', res)
        this.DataRfq = res.data.getRfqDetail
        console.log('rfq-detail', 'this.DataRfq', this.DataRfq)
        console.log('rfq-detail', 'this.DataRfq length', this.DataRfq.length)
        console.log('mmmm',this.DataRfq.rfqVendorCategory);



        this.companyAddress= this.DataRfq.companyLocation?.street+"<br>"+this.DataRfq.companyLocation?.city+" "+this.DataRfq.companyLocation?.country

        this.companyPhone = this.DataRfq.companyLocation?.phone


        var dataBoard ={
          city:this.DataRfq.companyLocation?.city,
          country:this.DataRfq.companyLocation.country,
          submitQuotationLastDate:this.DataRfq.submitQuotationLastDate,
          totalVendorParticipation:this.DataRfq.totalVendorParticipation,
          procurementName:'',
          rfqState:this.DataRfq.state,
          isAlreadyParticipating:this.DataRfq.isAlreadyParticipating,
          rfqVendorCategory:this.rfqVendorCategory,
          rfqDisplayId:this.DataRfq.rfqDisplayId,
          description:this.DataRfq.description,
          rfqItem:this.DataRfq.rfqItem,
          haveMoreRfqItem:(this.DataRfq.rfqItem.length>2)?true:false,
          sponsored:false,
          poId:this.step3 && !this.step4,
          isPoSent:this.step3 && this.step4,
          url:'',
        }
        console.log('dataBoard : ',dataBoard)
        this.dataRfqBoard=[]
        this.dataRfqBoard.push(dataBoard)

        

        var prepareData:any = {'id':this.DataRfq.id,'rfqDisplayId':this.DataRfq.rfqDisplayId}
        this.valshareData = prepareData
        
        var arrprod = res.data.getRfqDetail.rfqItem


        this.getCodeCurrency(res.data.getRfqDetail.currency)

        this.StatusApproval= res.data.getRfqDetail.approvalStatus

        if(arrprod){
          console.log('arrprod',arrprod.length);
          
          arrprod.forEach((e:any) => {
            this.arrMoreLessDesc.push('less')

            console.log('arr prod : ',e.id);

            this.offsetperitem[e.id]=0
            this.isLoadmore[e.id]=false
            
          })
          console.log('arr offsetperitem : ',this.offsetperitem);
          console.log('arrMoreLessDesc>> ',this.arrMoreLessDesc);

          //var arrprodLength = arrprod.length  
          // var a = 1
          // arrprod.forEach((e:any) => {
          //   // if(a==arrprodLength){
          //   //   this.productList.push({'collapse':true})
          //   // } else {
          //   //   this.productList.push({'collapse':false})
          //   // }
          //   console.log('e>>',e);

          //   // this.getAllVendorQuotationOfferedDataRfq(this.rfqId,e.id)

          //   this.productList.push({'collapse':false})
          //   a++
          // });
        }
        

        this.rfqVendorCategory = this.DataRfq.rfqVendorCategory.map((val: any) => { return val.category }).join(", ")
        this.statusRfq = this.DataRfq.state
        this.PageLoading = false
 
        this.getLowestHighestPriceRfq()

      }
      else if(res.errors){
        var error = res.errors[0].message
        console.log('error',error);
        var errMsg = error + '';
        var result = errMsg.split(":");
        var resMsg = result[result.length - 1];
        var msg = (resMsg)? resMsg: errMsg
        console.log('msg',msg);

        var errortext = msg

        console.log('res',res.errors[0].extensions.type);
        if(res.errors[0].extensions.type){
          //get translate error, if exsit, replace errortext
          this.translate.get('error.'+res.errors[0].extensions.type).subscribe((data:any)=> {
            if (this.translate.instant('error.'+res.errors[0].extensions.type) !== 'error.'+res.errors[0].extensions.type){
              errortext = data
            }
          });
          //force redirect on specific errortype
          var forceRedirect = CheckErrortype.getResponse(res.errors[0].extensions.type)
          if(forceRedirect){
            window.location.href = forceRedirect
            return
          }
        }
        this.popupmodal.showError(errortext,null).subscribe((res:any) => {})
      }
      else {
        this.popupmodal.showFail().subscribe((res:any) => {})
      }
      
    });

  }

  getLowestHighestPriceRfq(){
    this.apollo
      .mutate({
        mutation: getLowestHighestPriceRfq,
        variables: { rfqId: this.rfqId }
      })
      .subscribe(
        (res: any) => {
          console.log('getLowestHighestPriceRfq', 'res', res)
          this.DataLowestHighestPrice = res.data.getLowestHighestPrice
          console.log('getLowestHighestPriceRfq > res ',this.DataLowestHighestPrice);

        },
        error => {
          this.PageLoading = true
          console.log('error',error);
          var errMsg = error + '';
          var res = errMsg.split(":");
          var resMsg = res[res.length - 1];
          var msg = (resMsg)? resMsg: errMsg
          alert(msg)
      })    
  }

  getCompleteOrderQuotationRfq(){
    // this.apollo
    //   .mutate({
    //     mutation: getCompleteOrderQuotationRfq,
    //     variables: { rfqId: this.rfqId }
    //   })
    //   .subscribe(
    //     (res: any) => {
    //       console.log('getCompleteOrderQuotationRfq', 'res', res)
    //       this.DataCompleteOrderQuotation = res.data.getCompleteOrderQuotation
    //       console.log('getCompleteOrderQuotationRfq > res ',this.DataCompleteOrderQuotation);
          
    //     },
    //     error => {
    //       this.PageLoading = true
    //       console.log('error',error);
    //       var errMsg = error + '';
    //       var res = errMsg.split(":");
    //       var resMsg = res[res.length - 1];
    //       var msg = (resMsg)? resMsg: errMsg
    //       alert(msg)
    //   })  
      
      
      this.rfqProcurementService
      .getCompleteOrderQuotationRfq(this.rfqId)
      .subscribe((res:any) => {

        console.log('res : ',res)
        if(res.data?.getCompleteOrderQuotation){
          this.DataCompleteOrderQuotation= res.data.getCompleteOrderQuotation.completeOrderQuotation
          this.DataCompleteOrderQuotationOffer = res.data.getCompleteOrderQuotation.selectedOffer
          if(this.DataCompleteOrderQuotationOffer>0){
            this.emptyItem = false
          }
          this.DataCompleteOrderQuotation.forEach((e:any,i:any) => {
            this.arrVendorIdFull.push(e.vendorId)
          })

          this.getLogoFull() 



          setTimeout(() => this.downloadPdf(),2000);  //TODO: on dev commented
        }
        else if(res.errors){
  
          const modalRef = this.modalService.open(ModalComponent, {
            modalDialogClass: 'modal-dialog-centered div-modal-content',
            centered: true,
            backdrop : 'static',
            keyboard : false,
            size: 'sm'
          })
  
          var error = res.errors[0].message
          //this.loading=false
          console.log('error',error);
          var errMsg = error + '';
          var result = errMsg.split(":");
          var resMsg = result[result.length - 1];
          var msg = (resMsg)? resMsg: errMsg
          console.log('msg',msg);
          //alert(msg)
  
          var errortext = msg
  
          console.log('res',res.errors[0].extensions.type);
          if(res.errors[0].extensions.type){
            if(res.errors[0].extensions.type == 'StaffDoNotHaveAccess'){
              errortext = "You don't have access to this process"
            } 
          }
  
          modalRef.componentInstance.modalinfo = 'info'
          modalRef.componentInstance.infoTitle = 'Opps Something Wrong!' // 'Success!' 
          modalRef.componentInstance.infoSuccess = null
          modalRef.componentInstance.infoFailed = errortext
          modalRef.componentInstance.closeTxt = 'Close'
  
          modalRef.componentInstance.confirmedClick.subscribe((res: any) => {
            if (res){
              this.router.navigate(['/']);
            } 
          })
          
        }
        else {
    
          const modalRef = this.modalService.open(ModalComponent, {
            modalDialogClass: 'modal-dialog-centered div-modal-content',
            centered: true,
            backdrop : 'static',
            keyboard : false,
            size: 'sm'
          })
          modalRef.componentInstance.modalinfo = 'info'
          modalRef.componentInstance.infoTitle = 'Opps Something Wrong!' // 'Success!' 
          modalRef.componentInstance.infoSuccess = null
          modalRef.componentInstance.infoFailed = 'Please try again later'
          modalRef.componentInstance.closeTxt = 'Close'
  
          modalRef.componentInstance.confirmedClick.subscribe((res: any) => {
            if (res){
              this.router.navigate(['/']);
            } 
          })
        } 
      });

  }

  
  getRfqItemListDataRfq(){
    this.loadingrfqitem=true
    this.offset = this.limit * (this.currentpage -1)

    this.rfqProcurementService
    .getRfqItemListDataRfq(this.rfqId,this.limit,this.offset)
    .subscribe((res:any) => {

      console.log('res : ',res)
      if(res.data?.getRfqItemListData){
        console.log('getRfqItemListDataRfq', 'res', res)
        this.datagetRfqItemListDataRfq = res.data.getRfqItemListData; 
        this.totalAll = res.data.getRfqItemListData.totalItem
        
        this.isActivePoExist = res.data.getRfqItemListData.isActivePoExist

        this.productList=[]
        this.qtytoooffer = []
        this.qtytooofferchanges = []
        var a = 1
        var k = 0
        var totaloffer = 0
        res.data.getRfqItemListData?.quotedRfqItem.forEach((e:any) => {
          console.log('e>>',e);
          this.productList.push({'collapse':true})

          e.vendorQuotationOfferData.forEach((x:any) => {
            var quotitemid = x.quotationItemId
            // var quotid = x.quotationId
            var selectedqty = x.selectedQty
            // this.qtytoooffer[quotitemid]=selectedqty
            this.qtytooofferchanges[quotitemid]=selectedqty

            // this.qtytoooffer[k]['quotationid']=quotitemid
            // this.qtytoooffer[k]['qty']=selectedqty


            var object = {'quotationid':quotitemid,'qty':selectedqty}
            this.qtytoooffer.push(object);

            this.emptyItem = false
            this.arrVendorId.push(x.vendorId)
          })

          totaloffer = totaloffer + e.totalSelectedOffer

          a++
          k++
        });


        this.totalselected = totaloffer

        console.log('qtytoooffer',this.qtytoooffer);
        console.log('qtytooofferchanges',this.qtytooofferchanges);

        this.loadPaging()
        this.loadingrfqitem=false
        this.getLogo() 
      }
      else if(res.errors){

        const modalRef = this.modalService.open(ModalComponent, {
          modalDialogClass: 'modal-dialog-centered div-modal-content',
          centered: true,
          backdrop : 'static',
          keyboard : false,
          size: 'sm'
        })

        var error = res.errors[0].message
        //this.loading=false
        console.log('error',error);
        var errMsg = error + '';
        var result = errMsg.split(":");
        var resMsg = result[result.length - 1];
        var msg = (resMsg)? resMsg: errMsg
        console.log('msg',msg);
        //alert(msg)

        var errortext = msg

        console.log('res',res.errors[0].extensions.type);
        if(res.errors[0].extensions.type){
          if(res.errors[0].extensions.type == 'StaffDoNotHaveAccess'){
            errortext = "You don't have access to this process"
          } 
        }

        modalRef.componentInstance.modalinfo = 'info'
        modalRef.componentInstance.infoTitle = 'Opps Something Wrong!' // 'Success!' 
        modalRef.componentInstance.infoSuccess = null
        modalRef.componentInstance.infoFailed = errortext
        modalRef.componentInstance.closeTxt = 'Close'

        modalRef.componentInstance.confirmedClick.subscribe((res: any) => {
          if (res){
            this.router.navigate(['/']);
          } 
        })
        
      }
      else {
  
        const modalRef = this.modalService.open(ModalComponent, {
          modalDialogClass: 'modal-dialog-centered div-modal-content',
          centered: true,
          backdrop : 'static',
          keyboard : false,
          size: 'sm'
        })
        modalRef.componentInstance.modalinfo = 'info'
        modalRef.componentInstance.infoTitle = 'Opps Something Wrong!' // 'Success!' 
        modalRef.componentInstance.infoSuccess = null
        modalRef.componentInstance.infoFailed = 'Please try again later'
        modalRef.componentInstance.closeTxt = 'Close'

        modalRef.componentInstance.confirmedClick.subscribe((res: any) => {
          if (res){
            this.router.navigate(['/']);
          } 
        })
      } 
    });



    // this.apollo
    //   .mutate({
    //     mutation: getRfqItemListDataRfq,
    //     variables: { rfqId:this.rfqId,limit:this.limit, offset:this.offset }
    //   })
    //   .subscribe(
    //     (res: any) => {
    //       console.log('getRfqItemListDataRfq', 'res', res)
    //       this.datagetRfqItemListDataRfq = res.data.getRfqItemListData; 
    //       this.totalAll = res.data.getRfqItemListData.totalItem
          
    //       this.isActivePoExist = res.data.getRfqItemListData.isActivePoExist

    //       this.productList=[]
    //       this.qtytoooffer = []
    //       this.qtytooofferchanges = []
    //       var a = 1
    //       var k = 0
    //       res.data.getRfqItemListData?.quotedRfqItem.forEach((e:any) => {
    //         console.log('e>>',e);
    //         this.productList.push({'collapse':true})

    //         e.vendorQuotationOfferData.forEach((x:any) => {
    //           var quotitemid = x.quotationItemId
    //           // var quotid = x.quotationId
    //           var selectedqty = x.selectedQty
    //           // this.qtytoooffer[quotitemid]=selectedqty
    //           this.qtytooofferchanges[quotitemid]=selectedqty

    //           // this.qtytoooffer[k]['quotationid']=quotitemid
    //           // this.qtytoooffer[k]['qty']=selectedqty


    //           var object = {'quotationid':quotitemid,'qty':selectedqty}
    //           this.qtytoooffer.push(object);

    //           this.emptyItem = false

    //         })

            
    //         a++
    //         k++
    //       });
    //       console.log('qtytoooffer',this.qtytoooffer);
    //       console.log('qtytooofferchanges',this.qtytooofferchanges);

    //       this.loadPaging()
    //       this.loadingrfqitem=false
          
    //     },
    //     error => {
    //       this.PageLoading = true
    //       this.loadingrfqitem=false
    //       console.log('error',error);
    //       var errMsg = error + '';
    //       var res = errMsg.split(":");
    //       var resMsg = res[res.length - 1];
    //       var msg = (resMsg)? resMsg: errMsg
    //       alert(msg)
    //   })    
  }
  


  getAllVendorQuotationOfferedDataRfq(rfqId:any,rfqItemId:any){
    var limit=this.limitvendorloadmore
    var offset=0

    this.isLoadmore[rfqItemId]=true
    offset  = this.offsetperitem[rfqItemId]


    this.rfqProcurementService
    .getAllVendorQuotationOfferedDataRfq(rfqId,rfqItemId,limit,offset)
    .subscribe((res:any) => {
      console.log('res : ',res)
      if(res.data?.getAllVendorQuotationOfferedData){
        console.log('getAllVendorQuotationOfferedDataRfq', 'res', res)

        this.combineloadmore(rfqItemId,res.data.getAllVendorQuotationOfferedData.vendorQuotationOfferData)
        //this.DataAllVendorQuotationOfferedDataRfq[rfqItemId] = res.data.getAllVendorQuotationOfferedData.vendorQuotationOfferData; // add 
        //console.log('total DataAllVendorQuotationOfferedDataRfq : ',this.DataAllVendorQuotationOfferedDataRfq)
        this.totalalldata[rfqItemId] = res.data.getAllVendorQuotationOfferedData.totalData
        console.log('total data : ',this.totalalldata[rfqItemId])
        console.log('total data if : ',(this.offsetperitem[rfqItemId]+1)*limit < this.totalalldata[rfqItemId])
        if((this.offsetperitem[rfqItemId]+1)*limit < this.totalalldata[rfqItemId]){ // if 
          this.offsetperitem[rfqItemId] = (this.offsetperitem[rfqItemId]+1)*limit
          this.completeloadmore[rfqItemId]=false
        } else {
          this.completeloadmore[rfqItemId]=true
        }
        
        //1111111111//
        res.data.getAllVendorQuotationOfferedData.vendorQuotationOfferData.forEach((x:any) => {
          var quotitemid = x.quotationItemId
          // var quotid = x.quotationId
          var selectedqty = x.selectedQty
          // this.qtytoooffer[quotitemid]=selectedqty
          this.qtytooofferchanges[quotitemid]=selectedqty
    
          // this.qtytoooffer[k]['quotationid']=quotitemid
          // this.qtytoooffer[k]['qty']=selectedqty
    
          var notexist =0
          var object = {'quotationid':quotitemid,'qty':selectedqty,'hide':true}
          this.qtytoooffer.forEach((x:any) => {
              if(x.quotationid == quotitemid){
                notexist++
              } 
          });
          if(notexist==0){
            this.qtytoooffer.push(object);
          }
          this.arrVendorId.push(x.vendorId)
          
          //1111111111//
    
        })

        console.log('thisqtytoooffer',this.qtytoooffer)
        console.log('qtytooofferchanges',this.qtytooofferchanges)
        
        this.getLogo()
      }
      else if(res.errors){

        var error = res.errors[0].message
        //this.loading=false
        console.log('error',error);
        var errMsg = error + '';
        var result = errMsg.split(":");
        var resMsg = result[result.length - 1];
        var msg = (resMsg)? resMsg: errMsg
        console.log('msg',msg);
        //alert(msg)

        var errortext = msg

        console.log('res',res.errors[0].extensions.type);
        if(res.errors[0].extensions.type){
          //get translate error, if exsit, replace errortext
          this.translate.get('error.'+res.errors[0].extensions.type).subscribe((data:any)=> {
            if (this.translate.instant('error.'+res.errors[0].extensions.type) !== 'error.'+res.errors[0].extensions.type){
              errortext = data
            }
          });
          //force redirect on specific errortype
          var forceRedirect = CheckErrortype.getResponse(res.errors[0].extensions.type)
          if(forceRedirect){
            window.location.href = forceRedirect
            return
          }
        }
        this.popupmodal.showError(errortext,null).subscribe((res:any) => {})
      }
      else {
        this.popupmodal.showFail().subscribe((res:any) => {})
      }
    });



    // this.apollo
    //   .mutate({
    //     mutation: getAllVendorQuotationOfferedDataRfq,
    //     variables: { rfqId:rfqId,rfqItemId:rfqItemId,limit:limit, offset:offset }
    //   })
    //   .subscribe(
    //     (res: any) => {
    //       console.log('getAllVendorQuotationOfferedDataRfq', 'res', res)

    //       this.combineloadmore(rfqItemId,res.data.getAllVendorQuotationOfferedData.vendorQuotationOfferData)
    //       //this.DataAllVendorQuotationOfferedDataRfq[rfqItemId] = res.data.getAllVendorQuotationOfferedData.vendorQuotationOfferData; // add 
    //       //console.log('total DataAllVendorQuotationOfferedDataRfq : ',this.DataAllVendorQuotationOfferedDataRfq)
    //       this.totalalldata[rfqItemId] = res.data.getAllVendorQuotationOfferedData.totalData
    //       console.log('total data : ',this.totalalldata[rfqItemId])
    //       console.log('total data if : ',(this.offsetperitem[rfqItemId]+1)*limit < this.totalalldata[rfqItemId])
    //       if((this.offsetperitem[rfqItemId]+1)*limit < this.totalalldata[rfqItemId]){ // if 
    //         this.offsetperitem[rfqItemId] = (this.offsetperitem[rfqItemId]+1)*limit
    //         this.completeloadmore[rfqItemId]=false
    //       } else {
    //         this.completeloadmore[rfqItemId]=true
    //       }
    //       // limitloadmore=50
    //       // offsetloadmore=0 //page
    //       // totalalldata:any=[]
    //       // offsetperitem:any=[]

    //       //this.completeloadmore[rfqItemId]=true
    //     },
    //     error => {
    //       this.PageLoading = true
    //       console.log('error',error);
    //       var errMsg = error + '';
    //       var res = errMsg.split(":");
    //       var resMsg = res[res.length - 1];
    //       var msg = (resMsg)? resMsg: errMsg
    //       alert(msg)
    //   })    
  }
  
  combineloadmore(rfqid:any,data:any){
    var object = {id:rfqid,data:data}
    var found = 0
    this.DataAllVendorQuotationOfferedDataRfq.forEach((e:any,i:any) => {
      if(e['id']==rfqid){
        data.forEach((el:any) => {
          this.DataAllVendorQuotationOfferedDataRfq[i].data.push(el)
        });
        found++
      }
    });
    if(found == 0){
      this.DataAllVendorQuotationOfferedDataRfq.push(object);
    }
    console.log('DataAllVendorQuotationOfferedDataRfq',this.DataAllVendorQuotationOfferedDataRfq)
  }

  getListItemLoadMore(rfqid:any){
    var res : any =[]
    this.DataAllVendorQuotationOfferedDataRfq.forEach((e:any,i:any) => {
      if(e['id']==rfqid){
        res = e['data']
      }
    });
    return res
  }

  removeCategory(id: any) {

  }

  AccordionHideShow(i:any){

    console.log('--------------');

    if(this.productList[i]['collapse']==true){
      this.productList[i]['collapse']=false
    } else {
      this.productList[i]['collapse']=true
    }
    console.log('to',this.productList);
    console.log('--------------');
  }


  removeDivSpec(val:any){
    var string = val.replace(/<fhspecdiv>(.*?)<\/fhspecdiv>/g,'');
    return string
  }

  changeStateRFQ(state:any){
    this.PageLoading=true


    this.rfqProcurementService.postChangeRfqState(state,this.rfqId).subscribe((res:any) => {
      console.log(res)
  
      if(res.data?.changeRfqState){
        this.statusRfq=state
        this.PageLoading = false
        console.log('success',res);


        if(state=='CLOSE'){
          //this.successcancel='block'
          this.checkIsRatingAvailable()
        }
        else if(state=='VOID'){
          this.successvoid='block' 



          const modalRef = this.modalService.open(ModalComponent, {
            modalDialogClass: 'modal-dialog-centered div-modal-content',
            centered: true,
            size: 'md'
          })
  
          var titleNotif = 'Success'
          var descNotif = 'Your RFQ has been successfully VOID!!'
          var redirectNotif =''
          var textBtn = 'Close'

          this.translate.get('success.void_rfq').subscribe((data:any)=> {
            descNotif = data
          });

          modalRef.componentInstance.modalinfo = 'info'
          modalRef.componentInstance.infoTitle = titleNotif
          modalRef.componentInstance.infoSuccess = descNotif
          modalRef.componentInstance.infoFailed = null
          modalRef.componentInstance.closeTxt = textBtn
  
          modalRef.componentInstance.confirmedClick.subscribe((res: any) => {
            if (res){
              if(redirectNotif!==''){
                // this.router.navigate([redirectNotif]);
              }
            } 
          })

        }
        
        this.rfqDetail()


      }
      else if(res.errors){
        
        this.PageLoading = false

        var error = res.errors[0].message
        console.log('error',error);
        var errMsg = error + '';
        var result = errMsg.split(":");
        var resMsg = result[result.length - 1];
        var msg = (resMsg)? resMsg: errMsg
        console.log('msg',msg);
        var errortext = msg

        if(res.errors[0].extensions.type){
          //get translate error, if exsit, replace errortext
          this.translate.get('error.'+res.errors[0].extensions.type).subscribe((data:any)=> {
            if (this.translate.instant('error.'+res.errors[0].extensions.type) !== 'error.'+res.errors[0].extensions.type){
              errortext = data
            }
          });
          //force redirect on specific errortype
          var forceRedirect = CheckErrortype.getResponse(res.errors[0].extensions.type)
          if(forceRedirect){
            window.location.href = forceRedirect
            return
          }
        }
        this.popupmodal.showError(errortext,null).subscribe((res:any) => {})
      }
      else {
        
        this.PageLoading = false

        this.popupmodal.showFail().subscribe((res:any) => {})
      }
      
    });

    return
    // this.rfqId='test123'
    this.apollo
      .mutate({
        mutation: changeSateRfq,
        variables: { rfqId: this.rfqId, action:state } // publish void close
      })
      .subscribe(
        (res: any) => {
          this.statusRfq=state
          this.PageLoading = false
          console.log('success',res);


          if(state=='CLOSE'){
            //this.successcancel='block'
            this.checkIsRatingAvailable()
          }
          else if(state=='VOID'){
            this.successvoid='block' 



            const modalRef = this.modalService.open(ModalComponent, {
              modalDialogClass: 'modal-dialog-centered div-modal-content',
              centered: true,
              size: 'md'
            })
    
            var titleNotif = 'Success'
            var descNotif = 'Your RFQ has been successfully VOID!'
            var redirectNotif =''
            var textBtn = 'Close'
  
  
            modalRef.componentInstance.modalinfo = 'info'
            modalRef.componentInstance.infoTitle = titleNotif
            modalRef.componentInstance.infoSuccess = descNotif
            modalRef.componentInstance.infoFailed = null
            modalRef.componentInstance.closeTxt = textBtn
    
            modalRef.componentInstance.confirmedClick.subscribe((res: any) => {
              if (res){
                if(redirectNotif!==''){
                  // this.router.navigate([redirectNotif]);
                }
              } 
            })

          }
          
          this.rfqDetail()
        },
        error => {
          this.PageLoading = false
          console.log('error',error);
          var errMsg = error + '';
          var res = errMsg.split(":");
          console.log('res',res);
          var resMsg = res[res.length - 1];
          var msg = (resMsg)? resMsg: errMsg
          console.log('msg',msg);
          // alert(msg)
          this.popupmodal.showError(msg,null).subscribe((res:any) => {})
    
        })
  }

  checkIsRatingAvailable(){
    this.ratingService.getisActiveSentPoExistToRating(this.rfqId).subscribe((res:any) => {
      console.log(res)
      this.PageLoading=false
      if(res.data){

        // //alert(res.data.isActiveSentPoExistToRating)
        // if(res.data.isActiveSentPoExistToRating){
        //   //call modal modalprocurement
        // } else {
        //   //call modal modalprocurement
        // }

        const modalRef = this.modalService.open(ModalComponent, {
          modalDialogClass: 'modal-dialog-centered modalIcon',
          centered: true,
          size: 'md',
          backdrop : 'static',
          keyboard : false,
        })
    
        modalRef.componentInstance.modalRatingProcurement = 'modal'
        modalRef.componentInstance.pheader = 'Success' //'Something wrong'
        modalRef.componentInstance.ptype = 'procurement' //'vendor'
        modalRef.componentInstance.ptitle = 'RFQ has been closed!<br>Thank you for using Cepet Dapet.'
        if(res.data.isActiveSentPoExistToRating){
          modalRef.componentInstance.ptext = 'Would you like to rate your experience ?' //false
          modalRef.componentInstance.ptextyes = 'Rate Now' // 'Close'
          modalRef.componentInstance.ptextno = 'Close' // false
          modalRef.componentInstance.phaverating = 'Y' //'N' without redirect rating
        } else {
          modalRef.componentInstance.ptextyes = 'Close' // 'Close'
          modalRef.componentInstance.ptextno = false // false
          modalRef.componentInstance.phaverating = 'N' //'N' without redirect rating
        }

        modalRef.componentInstance.pstate = 'success' //'error'
        
        // modalRef.componentInstance.modalRatingProcurement = 'modal'
        // modalRef.componentInstance.pheader = 'Something wrong' //'Something wrong'
        // modalRef.componentInstance.ptitle = ''
        // modalRef.componentInstance.ptext = 'RFQ cannot be closed yet.'
        // modalRef.componentInstance.ptextyes = 'Close'
        // modalRef.componentInstance.ptextno = ''
        // modalRef.componentInstance.pstate = 'error' 
        // modalRef.componentInstance.phaverating = 'N' //'N' without redirect rating
    
        modalRef.componentInstance.confirmedClick.subscribe((btn: any) => {
          if(res.data.isActiveSentPoExistToRating){
            if (btn=='yes') this.router.navigate(['/procurement/rating/procurement-rating-list']);
            if (btn=='no')  this.router.navigate(['/procurement/rfq-list']);
          } else {
            if (btn=='yes') this.router.navigate(['/procurement/rfq-list']);
          }
    
        })
    
      }
      else if(res.errors){
        var error = res.errors[0].message
        console.log('error',error);
        var errMsg = error + '';
        var result = errMsg.split(":");
        var resMsg = result[result.length - 1];
        var msg = (resMsg)? resMsg: errMsg
        console.log('msg',msg);

        var errortext = msg

        console.log('res',res.errors[0].extensions.type);
        if(res.errors[0].extensions.type){
          //get translate error, if exsit, replace errortext
          this.translate.get('error.'+res.errors[0].extensions.type).subscribe((data:any)=> {
            if (this.translate.instant('error.'+res.errors[0].extensions.type) !== 'error.'+res.errors[0].extensions.type){
              errortext = data
            }
          });
          //force redirect on specific errortype
          var forceRedirect = CheckErrortype.getResponse(res.errors[0].extensions.type)
          if(forceRedirect){
            window.location.href = forceRedirect
            return
          }
        }
        this.popupmodal.showError(errortext,null).subscribe((res:any) => {})
      }
      else {
        this.popupmodal.showFail().subscribe((res:any) => {})
      }
      
    });
  }

  dashSeperate(input:any){
    var re = new RegExp('.{1,4}', 'g');
    return input?.match(re).join("-");
  }


  divspec(val:any){
    return Util.fhspectocomma(val)
  }
  divDetailspec(val:any){
    return Util.formatShortDesc(val)
  }
  divDetailspecLess(val:any){
    //return Util.formatShortDesc(val)
    var checkChar = Util.formatShortDesc(val)

    if(checkChar.length>50){
      checkChar = checkChar.substring(0,50) + '...'
    }
    return checkChar
  }
  MoreLessDesc(i:any,action:string){
    this.arrMoreLessDesc[i]=action; 
    console.log('arrMoreLessDesc',this.arrMoreLessDesc);
  }

  closeModal(){
    this.displaypublish='none'
    this.successpublish='none'
    this.successvoid='none' 
    this.displayisActivePoExist='none'
  }

  delete(val:any,name:any){
    console.log('delete',val);
    this.deleteID = []
    this.deleteID.push(val)

    this.deleteName = []
    this.deleteName.push(name)
  }

  confirmdelete()
  {
    this.PageLoading=true
    console.log('delete',this.rfqId);



    let productsId =this.rfqId
    this.apollo
    .mutate({
      mutation: deleteRfq,
      variables: {rfqId: productsId}
    })
    .subscribe(
      (res:any) => {
        console.log("succes delete, get data:", res);
        if(res.data){
          this.PageLoading=false
          this.displaydone = "block";
        }
      },
      error => {
        this.PageLoading=false
        //alert(error)
        console.log("there was an error sending the delete query", error);   
        // alert('Error while delete product. Please refresh and try again.')       
        var errMsg = error + '';
        var res = errMsg.split(":");
        var resMsg = res[res.length - 1];
        var msg = (resMsg)? resMsg: errMsg
        //alert(msg)
      }
    );


  }

  getRandom(min:any, max:any) {
    var rand = Math.random() * (max - min) + min;
    return parseFloat(rand).toFixed(1)
  }

  calculate(string1:any,string2:any,symbol:any){
    var res = Number(string1)
    if(string2!==''){
      res = eval(string1+' '+symbol+' '+string2)
    }
    return res
  }
  openRfqMorebyItem(itemid:any){
    console.log('openRfqMorebyItem >> ',itemid);
    this.getAllVendorQuotationOfferedDataRfq(this.rfqId,itemid)
  }


  loadPaging(){
    var gettotal = Math.ceil(this.totalAll/this.limit)

    if(this.currentpage==gettotal){
      this.hasnext=false
    } else {
      this.hasnext=true
    }

    if(this.currentpage==1){
      this.hasprev=false
    } else {
      this.hasprev=true
    }

    this.totalpage = gettotal


    console.log('totalpage hasprev',this.hasprev);
    console.log('totalpage hasnext',this.hasnext);

    console.log('totalpage gettotal',gettotal);
    console.log('totalpage currentpage',this.currentpage);
    console.log('totalpage totalAll',this.totalAll);
    console.log('totalpage totalpage',this.totalpage);

    if(this.totalpage==0){
      this.hasnext=false
    }
    console.log('totalpage xxxx',this.totalAll);
  }


  gotopage(page:any){
    if(this.btnQtyEnable){
      alert("there is a changes in QTY to Order, please confirm and click 'Save' before go to other page")
    } else {
      this.currentpage=page
      this.getRfqItemListDataRfq()
    }

  }
  
  openVendorRFQdetail(quotationrfqid:any){
    console.log('quotationrfqid',quotationrfqid);
    alert('quotation id : '+quotationrfqid);
  }

  modifyQty(quotationid:any,updateqty:any){
    console.log('===============');
    console.log('===> ',quotationid);
    console.log('===> ',updateqty.target);
    // this.ArrQtytoOffer = []
    // console.log(this.ArrQtytoOffer);
    console.log('qtytoooffer',this.qtytoooffer)
    console.log('qtytooofferchanges',this.qtytooofferchanges)
    
    //JSON.stringify(this.qtytoooffer)==JSON.stringify(this.qtytooofferchanges)

    //if(JSON.stringify(this.qtytoooffer)==JSON.stringify(this.qtytooofferchanges)){
    //   console.log('sama')
    // } else {
    //   console.log('ga sama')
    // }
    this.qtytoooffer.forEach((element:any) => {
      console.log('element.quotationid',element.quotationid);
      console.log('this.qtytooofferchanges[element.quotationid]',this.qtytooofferchanges[element.quotationid]);
      console.log('element.qty',element.qty);


      var index = this.qtytoooffer.findIndex((x: { quotationid: any; }) => x.quotationid ===element.quotationid);
      console.log('indexxxx,',index);
      console.log('indexxxx,',this.qtytoooffer[index].qty);
      if(this.qtytooofferchanges[element.quotationid]==this.qtytoooffer[index].qty){
        this.qtytoooffer[index]['changes']=false
      } else {
        this.qtytoooffer[index]['changes']=true
      }
      console.log('haschanges,',this.qtytoooffer);
    });
    console.log('===============');

    var enable = 0
    this.qtytoooffer.forEach((el:any) => {
      if(el.changes == true){
        enable++
      } 
    })
    if(enable>0){
        this.btnQtyEnable = true      
    } else {
      this.btnQtyEnable = false   
    }
  }




  updateRequestQty(){

    console.log('qtytooofferchanges',this.qtytooofferchanges);
    console.log('qtytoooffer',this.qtytoooffer);

    var dataUpdateQty:any=[]
    this.qtytoooffer.forEach((e:any) => {
      if(e.changes){
        var newQty = this.qtytooofferchanges[e.quotationid]
        var object = {'quotationItemId':e.quotationid,'selectedQty':newQty}
        dataUpdateQty.push(object);
      }
    });
    console.log('dataUpdateQty',dataUpdateQty)
    this.PostUpdateItem(dataUpdateQty)
    //if qtytoooffer changes true, make new array to push, get qty from qtytooofferchanges
  }

  
  PostUpdateItem(arrItem:any){
    this.loadingrfqitem=true
    this.apollo
      .mutate({
        mutation: PostUpdateItemRfq,
        variables: { rfqId:this.rfqId,updateRfqQuotationSelectedQtyInputData:arrItem }
      })
      .subscribe(
        (res: any) => {
          console.log('PostUpdateItemRfq', 'res', res)
          alert('Success update qty to offer')
          this.getRfqItemListDataRfq()
          this.loadingrfqitem=false
          this.btnQtyEnable = false
        },
        error => {
          this.loadingrfqitem=false
          console.log('error',error);
          var errMsg = error + '';
          var res = errMsg.split(":");
          var resMsg = res[res.length - 1];
          var msg = (resMsg)? resMsg: errMsg
          alert(msg)
      })    
  }

  hideclosemodal(){
    if(this.displaydone=='block'){
      this.displaydone = 'none'
    } else {
      this.displaydone = 'block'
    }
  }


  CanApproveReject(){

  }

  reqeustApproval(id:any,action:any){
    console.log('action',action);
    console.log('id',id);

    if(action=='APPROVE' || action=='REJECT'){
      this.openModalApproveReject()
      console.log('appr / reject')
    } else {
      console.log('request')
    }


    this.LoadingreqeustApproval=true

    this.apollo
    .mutate({
      mutation: changeRfqApprovalStatus,
      variables: {action:action,rfqId: id}
    })
    .subscribe(
      (res:any) => {
        this.LoadingreqeustApproval=false
        console.log("succes request approval, get data:", res);


        if(action=='APPROVE'){
          this.StatusApproval=4
          console.log('appr reject',this.StatusApproval)
        }
        else if(action=='REJECT'){
          this.StatusApproval=1
        }
        else if(action=='REQUEST'){
          console.log('request')
          this.StatusApproval=2
        }
        else {
          this.StatusApproval=1 
        }
        console.log('StatusApproval',this.StatusApproval)
    

        //this.getDataEdit(this.EditProductId)

        // if(action=='APPROVE' || action=='REJECT'){
        //   this.openModalApproveReject()
        //   console.log('appr / reject')

        // } else {
        //   console.log('request')
        // }

        // if(res.data){
        //   //alert('Delete Successfully')
        //   console.log("ada data");
        //   this.router.navigate(['/vendor/products']);
        // }

        this.getStepper()
      },
      error => {
        this.LoadingreqeustApproval=false

        console.log('error',error);
        var errMsg = error + '';
        var res = errMsg.split(":");
        var resMsg = res[res.length - 1];
        var msg = (resMsg)? resMsg: errMsg
        //alert(msg)
        this.popupmodal.showError(msg,null).subscribe((res:any) => {})
      }
    );






  }

  openModalApproveReject(){
    if(this.displayApproveReject=="none"){
      this.displayApproveReject = "block";
    } else {
      this.displayApproveReject = "none";
    }
  }
  OpenModalTimeLine(){
    if(this.displaytimeline=="none"){
      this.displaytimeline = "block";
    } else {
      this.displaytimeline = "none";
    }
    console.log('displaytimeline',this.displaytimeline);
  }

  checkisActivePoExist(){
    if(this.isActivePoExist){
      this.displayisActivePoExist='block'
    } else {
      this.router.navigate(['/procurement/rfq/quoted/edit/'+this.rfqId]);
    }
  }

  showModalInviteVendor(){
    console.log('showInviteVendor : ',this.showInviteVendor)
    if(this.showInviteVendor=='none'){
      this.showInviteVendor='block'
      if(this.vendorList.length==0){
        this.getListVendor()
      }
    } else {
      this.showInviteVendor='none'
    }  
    console.log('showInviteVendor : ',this.showInviteVendor)
  }

  getListVendor(){
    this.loadvendor = true
    this.rfqProcurementService
    .getFavouriteVendorList()
    .subscribe((res:any) => {
      this.loadvendor = false
      console.log('res : ',res)
      if(res.data?.viewFavouriteVendorList){
        this.vendorList= res.data.viewFavouriteVendorList
      }
      else if(res.errors){

        const modalRef = this.modalService.open(ModalComponent, {
          modalDialogClass: 'modal-dialog-centered div-modal-content',
          centered: true,
          backdrop : 'static',
          keyboard : false,
          size: 'sm'
        })

        var error = res.errors[0].message
        //this.loading=false
        console.log('error',error);
        var errMsg = error + '';
        var result = errMsg.split(":");
        var resMsg = result[result.length - 1];
        var msg = (resMsg)? resMsg: errMsg
        console.log('msg',msg);
        //alert(msg)

        var errortext = msg

        console.log('res',res.errors[0].extensions.type);
        if(res.errors[0].extensions.type){
          if(res.errors[0].extensions.type == 'StaffDoNotHaveAccess'){
            errortext = "You don't have access to this process"
          } 
        }

        modalRef.componentInstance.modalinfo = 'info'
        modalRef.componentInstance.infoTitle = 'Opps Something Wrong!' // 'Success!' 
        modalRef.componentInstance.infoSuccess = null
        modalRef.componentInstance.infoFailed = errortext
        modalRef.componentInstance.closeTxt = 'Close'

      }
      else {
  
        const modalRef = this.modalService.open(ModalComponent, {
          modalDialogClass: 'modal-dialog-centered div-modal-content',
          centered: true,
          backdrop : 'static',
          keyboard : false,
          size: 'sm'
        })
        modalRef.componentInstance.modalinfo = 'info'
        modalRef.componentInstance.infoTitle = 'Opps Something Wrong!' // 'Success!' 
        modalRef.componentInstance.infoSuccess = null
        modalRef.componentInstance.infoFailed = 'Please try again later'
        modalRef.componentInstance.closeTxt = 'Close'

        modalRef.componentInstance.confirmedClick.subscribe((res: any) => {
          if (res){
            this.router.navigate(['/']);
          } 
        })
      } 
    });

    
  }

  selectVendor(id:any,name:any){
    this.addVendorToArr(id,name,'vendor')
  }

  addVendorToArr(id:string,name:string,type:string){
    //check if exist
    var exist = false
    if(this.selectedInvVendor.length==0){
      this.selectedInvVendor.push({'id':id,'val':name,'type':type})
    } else {
      this.selectedInvVendor.forEach((e:any,i:any) => {
        if(e.type==type){
          if(e.val==name){
              //if not exist , push
              exist = true
          }
        }
      });
      if(!exist){
        this.selectedInvVendor.push({'id':id,'val':name,'type':type})
      }
    }

  }

  removeInvVendor(id:any){
    
    
    this.selectedInvVendor.forEach((e:any,i:any) => {
      if(e.id==id){
        this.selectedInvVendor.splice(i, 1)
      }
    });
  }
  addInvEmail(){
    this.submitInvEmail=true
    

    const validateEmail = (email: string) => {
      return email.match(
        // /^([a-zA-Z0-9.!#\$%&'*+\\=?^_`{|}~-]+@[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]+\\.[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/

        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
 

      );
    };

    if(this.ValinputEmail){
      console.log('validate email : ',validateEmail(this.ValinputEmail))
      if(validateEmail(this.ValinputEmail)){
        this.addVendorToArr(this.ValinputEmail,this.ValinputEmail,'email')
        this.submitInvEmail=false
        this.invalidEmail=false
        this.ValinputEmail=''
      } else {
        this.invalidEmail=true
      }

    } else {
      this.invalidEmail=true
    }
  }
  submitInv(){

      this.inviteloading=true

      var rfqId = this.rfqId
      var usingInviteVendorID:any = []
      var usingInviteEmail:any = []

      this.selectedInvVendor.forEach((e:any,i:any) => {
        console.log(e)
        if(e.type=='email'){
          usingInviteEmail.push(e.id)
        }
        if(e.type=='vendor'){
          usingInviteVendorID.push(e.id)
        }
      });
      


      if(!this.checkInvitation()){
        this.inviteloading=false

        var errMsg = "Please select Vendor or input email address!"
        this.translate.get('rfq.email_inivite_empty').subscribe((data:any)=> {
          errMsg = data
        });
        this.popupmodal.showError(errMsg,null).subscribe((res:any) => {})
        return
      }

      this.rfqProcurementService
      .postinviteVendorToRfq(rfqId,usingInviteVendorID,usingInviteEmail)
      .subscribe((res:any) => {
        this.inviteloading=false
        this.ValinputEmail=''
        this.submitInvEmail=false
        this.invalidEmail=false
        this.showInviteVendor='none'
        this.selectedInvVendor=[]

        console.log('res : ',res)
        if(res.data?.inviteVendorToRfq){

          const modalRef = this.modalService.open(ModalComponent, {
            modalDialogClass: 'modal-dialog-centered div-modal-content',
            centered: true,
            backdrop : 'static',
            keyboard : false,
            size: 'sm'
          })
          modalRef.componentInstance.modalinfo = 'info'
          modalRef.componentInstance.infoTitle = 'Success!' // 'Success!' 
          modalRef.componentInstance.infoSuccess = 'Invitation sent.'
          modalRef.componentInstance.infoFailed = null
          modalRef.componentInstance.closeTxt = 'Close'
          modalRef.componentInstance.IdBtnClose = 'mtmInviteVendor'
  
          // modalRef.componentInstance.confirmedClick.subscribe((res: any) => {
          //   if (res){
          //     this.router.navigate(['/']);
          //   } 
          // })


        }
        else if(res.errors){
  
          const modalRef = this.modalService.open(ModalComponent, {
            modalDialogClass: 'modal-dialog-centered div-modal-content',
            centered: true,
            backdrop : 'static',
            keyboard : false,
            size: 'sm'
          })
  
          var error = res.errors[0].message
          //this.loading=false
          console.log('error',error);
          var errMsg = error + '';
          var result = errMsg.split(":");
          var resMsg = result[result.length - 1];
          var msg = (resMsg)? resMsg: errMsg
          console.log('msg',msg);
          //alert(msg)
  
          var errortext = msg
  
          console.log('res',res.errors[0].extensions.type);
          if(res.errors[0].extensions.type){
            if(res.errors[0].extensions.type == 'StaffDoNotHaveAccess'){
              errortext = "You don't have access to this process"
            } 
          }
  
          modalRef.componentInstance.modalinfo = 'info'
          modalRef.componentInstance.infoTitle = 'Opps Something Wrong!' // 'Success!' 
          modalRef.componentInstance.infoSuccess = null
          modalRef.componentInstance.infoFailed = errortext
          modalRef.componentInstance.closeTxt = 'Close'
  
        }
        else {
    
          const modalRef = this.modalService.open(ModalComponent, {
            modalDialogClass: 'modal-dialog-centered div-modal-content',
            centered: true,
            backdrop : 'static',
            keyboard : false,
            size: 'sm'
          })
          modalRef.componentInstance.modalinfo = 'info'
          modalRef.componentInstance.infoTitle = 'Opps Something Wrong!' // 'Success!' 
          modalRef.componentInstance.infoSuccess = null
          modalRef.componentInstance.infoFailed = 'Please try again later'
          modalRef.componentInstance.closeTxt = 'Close'
  
          modalRef.componentInstance.confirmedClick.subscribe((res: any) => {
            if (res){
              this.router.navigate(['/']);
            } 
          })
        } 
      });


  }

  checkInvitation(){
    var usingInviteVendorID:any = []
    var usingInviteEmail:any = []

    this.selectedInvVendor.forEach((e:any,i:any) => {
      console.log(e)
      if(e.type=='email'){
        usingInviteEmail.push(e.id)
      }
      if(e.type=='vendor'){
        usingInviteVendorID.push(e.id)
      }
    });
    
    if(usingInviteEmail.length>0 || usingInviteVendorID.length>0){
      return true
    }  
    
    return false

  }

  showModalReccurring(){
    if(this.showReccurring=='none'){
      this.showReccurring='block'
      this.ValReccurringName=''
      this.invalidRecName=false
      this.submitRecc = false
    } else {
      this.showReccurring='none'
    }  
  }
  submitReccurring(){
    this.submitRecc = true

    if(this.ValReccurringName.length>3){

      this.loadingReccurring=true

      this.rfqProcurementService
      .postaddRfqToRecurringList(this.rfqId,this.ValReccurringName)
      .subscribe((res:any) => {
  
        
        this.showReccurring='none'
        this.ValReccurringName=''
        this.loadingReccurring=false
        this.invalidRecName=false
        this.submitRecc = false
  
        console.log('res : ',res)
        if(res.data?.addRfqToRecurringList){
  
          const modalRef = this.modalService.open(ModalComponent, {
            modalDialogClass: 'modal-dialog-centered div-modal-content',
            centered: true,
            backdrop : 'static',
            keyboard : false,
            size: 'sm'
          })
          modalRef.componentInstance.modalinfo = 'info'
          modalRef.componentInstance.infoTitle = 'Success!' // 'Success!' 
          modalRef.componentInstance.infoSuccess = 'Success added to recurring RFQ.'
          modalRef.componentInstance.infoFailed = null
          modalRef.componentInstance.closeTxt = 'Close'
  
          // modalRef.componentInstance.confirmedClick.subscribe((res: any) => {
          //   if (res){
          //     this.router.navigate(['/']);
          //   } 
          // })
  
  
        }
        else if(res.errors){
  
          const modalRef = this.modalService.open(ModalComponent, {
            modalDialogClass: 'modal-dialog-centered div-modal-content',
            centered: true,
            backdrop : 'static',
            keyboard : false,
            size: 'sm'
          })
  
          var error = res.errors[0].message
          //this.loading=false
          console.log('error',error);
          var errMsg = error + '';
          var result = errMsg.split(":");
          var resMsg = result[result.length - 1];
          var msg = (resMsg)? resMsg: errMsg
          console.log('msg',msg);
          //alert(msg)
  
          var errortext = msg
  
          console.log('res',res.errors[0].extensions.type);
          if(res.errors[0].extensions.type){
            if(res.errors[0].extensions.type == 'StaffDoNotHaveAccess'){
              errortext = "You don't have access to this process"
            } 
          }
  
          modalRef.componentInstance.modalinfo = 'info'
          modalRef.componentInstance.infoTitle = 'Opps Something Wrong!' // 'Success!' 
          modalRef.componentInstance.infoSuccess = null
          modalRef.componentInstance.infoFailed = errortext
          modalRef.componentInstance.closeTxt = 'Close'
  
        }
        else {
    
          const modalRef = this.modalService.open(ModalComponent, {
            modalDialogClass: 'modal-dialog-centered div-modal-content',
            centered: true,
            backdrop : 'static',
            keyboard : false,
            size: 'sm'
          })
          modalRef.componentInstance.modalinfo = 'info'
          modalRef.componentInstance.infoTitle = 'Opps Something Wrong!' // 'Success!' 
          modalRef.componentInstance.infoSuccess = null
          modalRef.componentInstance.infoFailed = 'Please try again later'
          modalRef.componentInstance.closeTxt = 'Close'
  
          modalRef.componentInstance.confirmedClick.subscribe((res: any) => {
            if (res){
              this.router.navigate(['/']);
            } 
          })
        } 
      });
    } else {
      this.invalidRecName=true
    }


  }


  redirectRepeatRfq(){
     console.log('redirectRepeatRfq')
    localStorage.setItem("RepeatRfq",JSON.stringify(this.DataRfq))
    this.router.navigate(['procurement/rfq']);
  }

  sendMessage(quotationItemId:any){
    const modalRef = this.modalService.open(PopupmessagingComponent, {
      modalDialogClass: '',
      centered: true,
      backdrop : 'static',
      keyboard : false,
      size: 'md'
    })

    modalRef.componentInstance.title = 'Ask Vendor'
    modalRef.componentInstance.sendMessageAs = 'PROCUREMENT'
    modalRef.componentInstance.rfqid = this.rfqId
    modalRef.componentInstance.quotationId = quotationItemId
  }

  getVendorLogo(vendorId:string){
    console.log('getVendorLogo :: ',vendorId)

    this.productService.getVendorLogo('',vendorId)
    .subscribe((res:any) => {
      console.log(res)
      // if(res.data.getVendorLogo){
      //   this.arrLogo.push({'vendorId':vendorId,'imgUrl':res.data.getVendorLogo})
      //   this.logosVendor[vendorId]=res.data.getVendorLogo
      //   console.log('arrLogo :: ',this.arrLogo)
      //   console.log('logosVendor :: ',this.logosVendor)
      // } 
      if(res.data){
        this.arrLogo.push({'vendorId':vendorId,'imgUrl':res.data.getVendorLogo})
        console.log('arrLogo :: ',this.arrLogo)
      }

    });

    
  }

  getUrlLogo(vendorId:string){
    var img = ''
    this.arrLogo.forEach((e:any,i:any) => {
      if(e.vendorId==vendorId){
        img=e.imgUrl
      }
    });
    return img
  }

  getLogo(){
    this.arrVendorId.forEach((element:string,index:number) => {
      this.callapiLogo(element)
    });
  }

  callapiLogo(vendorid:string){
    const getVendorLogo = gql`
    query getVendorLogo($vendorDomain:String,$vendorId:String){
      getVendorLogo(input: {
          vendorDomain: $vendorDomain
          vendorId: $vendorId
      })
    }
    `;
    this.apollo.watchQuery<any>({
      query: getVendorLogo,
      variables: {
        vendorId: vendorid,
      },
    })
      .valueChanges
      .subscribe(({ data }) => {
        console.log('data getLogo ', data);
        if(data){
          this.arrLogo.push({'vendorId':vendorid,'imgUrl':data.getVendorLogo})
        } else {
          this.arrLogo.push({'vendorId':vendorid,'imgUrl':''})
        }
      }) 
  }

  getUrlLogoFull(vendorId:string){
    var img = ''
    this.arrLogoFull.forEach((e:any,i:any) => {
      if(e.vendorId==vendorId){
        img=e.imgUrl
      }
    });
    return img
  }

  getLogoFull(){
    this.arrVendorIdFull.forEach((element:string,index:number) => {
      this.callapiLogoFull(element)
    });
  }

  callapiLogoFull(vendorid:string){
    const getVendorLogo = gql`
    query getVendorLogo($vendorDomain:String,$vendorId:String){
      getVendorLogo(input: {
          vendorDomain: $vendorDomain
          vendorId: $vendorId
      })
    }
    `;
    this.apollo.watchQuery<any>({
      query: getVendorLogo,
      variables: {
        vendorId: vendorid,
      },
    })
      .valueChanges
      .subscribe(({ data }) => {
        console.log('data getLogo ', data);
        if(data){
          this.arrLogoFull.push({'vendorId':vendorid,'imgUrl':data.getVendorLogo})
        } else {
          this.arrLogoFull.push({'vendorId':vendorid,'imgUrl':''})
        }
      }) 
  }

  formatDisplayId(displayId: any) {
    if(displayId){
      console.log('displayId >> ',displayId)
      var re = new RegExp('.{1,4}', 'g');
      return displayId.match(re).join("-");
    } else {
      return "";
    }
  }

  saveAndSendPo(){
    

    this.rfqProcurementService.postApproveAndSendPO(this.rfqId).subscribe((res:any) => {
      if(res.data?.approveAndSendPO){

        // this.popupmodal.showSuccess('Success update quote!','/procurement/rfq/quoted/detail/'+this.rfqId).subscribe((res:any) => {})
        this.popupmodal.showSuccess('Success save and send PO!','procurement/rfq/proforma-po/'+this.rfqId).subscribe((res:any) => {})

      }
      else if(res.errors){
        var error = res.errors[0].message
        console.log('error',error);
        var errMsg = error + '';
        var result = errMsg.split(":");
        var resMsg = result[result.length - 1];
        var msg = (resMsg)? resMsg: errMsg
        console.log('msg',msg);
        var errortext = msg

        if(res.errors[0].extensions.type){
          //get translate error, if exsit, replace errortext
          this.translate.get('error.'+res.errors[0].extensions.type).subscribe((data:any)=> {
            if (this.translate.instant('error.'+res.errors[0].extensions.type) !== 'error.'+res.errors[0].extensions.type){
              errortext = data
            }
          });
          //force redirect on specific errortype
          var forceRedirect = CheckErrortype.getResponse(res.errors[0].extensions.type)
          if(forceRedirect){
            window.location.href = forceRedirect
            return
          }
        }
        this.popupmodal.showError(errortext,null).subscribe((res:any) => {})
      }
      else {
        this.popupmodal.showFail().subscribe((res:any) => {})
      }
      
    });

  }

  async downloadPdf() {

    let data = document.getElementById("exportpdf"); 
    // let data = document.getElementById("maindiv");
    console.log(data);  
    if(data){

      data.style.overflow = "inherit";
      data.style.maxHeight = "inherit";

    await html2canvas(data, { scrollY: -window.scrollY, scale: 1 }).then(
      canvas => {
        const contentDataURL = canvas.toDataURL("image/png", 1.0);
        // enabling the scroll
        // document.getElementById("alldata").style.overflow = "scroll";
        // document.getElementById("alldata").style.maxHeight = "150px";

        let pdf = new jspdf("p", "mm", "a4"); // A4 size page of PDF

        let imgWidth = 210; //300
        let pageHeight = pdf.internal.pageSize.height;
        let imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        let position = 0;

        pdf.addImage(contentDataURL, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(contentDataURL, "PNG", 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }
        // window.open(
        //   pdf.output("bloburl", { filename: "new-file.pdf" }),
        //   "_blank"
        // );

        // pdf.addImage(contentDataURL, 'PNG', 0, 0,21.0, 29.7);  

        const dt = new Date();
        const padL = (nr:any, len = 2, chr = `0`) => `${nr}`.padStart(2, chr);

        pdf.save(''+dt.getFullYear()+padL(dt.getMonth()+1)+padL(dt.getDate())+padL(dt.getHours())+padL(dt.getMinutes())+padL(dt.getSeconds())+'.pdf');  
      }
    );
    }
  }


}
